export default "__VITE_ASSET__1d35f82d__"